module.exports = __webpack_public_path__ + "img/bg-cant-find_small.badf39c8.jpg";